import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  CREATE,
  UPDATE,
  DELETE,
  DELETE_MANY,
  GET_MANY_REFERENCE
} from 'react-admin';
import {
  GetListService,
  GetOneService,
  GetManyService,
  GetManyReferenceService,
  UpdateService,
  CreateService,
  DeleteService
} from '../services';

const convertFirebaseResponseToDataProvider = (type, resource, params) => {
  const getListRequest = new GetListService();
  const getOneRequest = new GetOneService();
  const getManyRequest = new GetManyService();
  const getManyReferenceRequest = new GetManyReferenceService();
  const updateRequest = new UpdateService();
  const createRequest = new CreateService();
  const deleteRequest = new DeleteService();

  console.log('DataProvider PARAMS, ', params);
  switch (type) {
    case GET_LIST:
      return getListRequest.getList(resource, params);

    case GET_ONE:
      return getOneRequest.getOne(resource, params);

    case GET_MANY:
      return getManyRequest.getMany(resource, params);

    case GET_MANY_REFERENCE:
      return getManyReferenceRequest.getManyReference(resource, params);

    case UPDATE:
      return updateRequest.updateOne(resource, params);

    case CREATE:
      return createRequest.createOne(resource, params);

    case DELETE:
      return deleteRequest.deleteOne(resource, params);

    case DELETE_MANY:
      return deleteRequest.deleteMany(resource, params);
    default:
      return;
  }
};

// return : { Promise } for response
export const DataProvider = (type, resource, params) => {
  console.warn(
    'formatFirebaseQueryFromDataProvider DataProvider',
    type,
    resource,
    params
  );
  return convertFirebaseResponseToDataProvider(type, resource, params).then(
    response => {
      console.log(
        'convertFirebaseResponseToDataProvider response : ',
        response
      );
      return response;
    }
  );
};



// WEBPACK FOOTER //
// ./src/providers/dataProvider.js